/**
 * Protected route for VIVA HUB pages
 */

import React from 'react'
import { Navigate } from 'react-router-dom'
import { useSchedulerAuth } from '../../contexts/SchedulerAuthContext'
import { isSessionExpired } from '../../utils/scheduler/auth'
import { hasPermission } from '../../constants/hub-apps'

export function HubProtectedRoute({ children, appPermission = null }) {
  let authContext
  try {
    authContext = useSchedulerAuth()
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('HubProtectedRoute: auth context unavailable', error)
    }
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600" />
      </div>
    )
  }

  const { user, loading } = authContext

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600" />
      </div>
    )
  }

  if (user && isSessionExpired()) {
    return <Navigate to="/hub/login" replace />
  }

  if (!user) {
    return <Navigate to="/hub/login" replace />
  }

  if (appPermission && !hasPermission(user, appPermission)) {
    return <Navigate to="/hub" replace />
  }

  return children
}
